import React, { useEffect, useState } from "react";
import { PageHeader, Loader, Empty, StatCard } from "@/components/shared";
import { Wallet } from "lucide-react";
import { api } from "@/lib/api";
import { useI18n } from "@/lib/i18n";
import { fmtPKR, fmtDate } from "@/lib/format";

export default function Balance() {
  const { t } = useI18n();
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/balance/transactions").then(({ data }) => setData(data)).catch(() => {}); }, []);
  if (!data) return <Loader />;

  const kindColor = { stake: "text-red-400", reward: "text-emerald-400", spin: "text-orange-400", referral: "text-purple-400", bonus: "text-yellow-400", capital_credit: "text-yellow-400", deposit: "text-emerald-400", withdrawal: "text-red-400", refund: "text-blue-400", admin_adjust: "text-gray-300", aviator_bet: "text-red-400", aviator_win: "text-emerald-400", aviator_refund: "text-blue-400", cups_bet: "text-red-400", cups_win: "text-emerald-400", dnd_bet: "text-red-400", dnd_win: "text-emerald-400" };

  return (
    <div>
      <PageHeader title={t("balance")} subtitle="Your wallet and full transaction history." />
      <div className="max-w-sm mb-8"><StatCard icon={Wallet} label={t("current_balance")} value={fmtPKR(data.balance)} accent="orange" testid="balance-card" /></div>
      <h3 className="font-head text-lg font-semibold text-white mb-4">Transaction History</h3>
      {data.transactions.length === 0 ? <Empty label="No transactions yet." /> : (
        <div className="ec-card divide-y divide-white/5">
          {data.transactions.map((tx) => (
            <div key={tx.id} className="flex items-center justify-between px-5 py-4" data-testid={`txn-${tx.id}`}>
              <div>
                <p className="text-sm text-white font-medium">{tx.description}</p>
                <p className="text-xs text-gray-500 capitalize">{tx.kind} · {fmtDate(tx.created_at)}</p>
              </div>
              <span className={`font-head font-bold ${kindColor[tx.kind] || "text-gray-300"}`}>{tx.amount >= 0 ? "+" : ""}{fmtPKR(tx.amount)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
